import { Link, type LinkRootProps } from "@heroui/react";

/**
 * Constrained link props.
 * className escape hatch available for one-off overrides.
 */
export type AppLinkProps = Omit<LinkRootProps, "className"> & {
  /** Optional className escape hatch for one-off overrides. */
  className?: string;
};

/**
 * AppLink root — Design system navigational link.
 */
function AppLinkRoot({ className, ...props }: AppLinkProps) {
  return <Link {...props} className={className} />;
}

/**
 * AppLink — Design system link.
 *
 * Wraps HeroUI v3 Link with Rosé Pine theme integration.
 * No custom variants — accent color is applied via CSS theme.
 * Sub-component (Icon) is a HeroUI pass-through.
 *
 * @example
 * ```tsx
 * <AppLink href="/settings">
 *   Settings
 *   <AppLink.Icon />
 * </AppLink>
 * ```
 */
export const AppLink = Object.assign(AppLinkRoot, {
  Icon: Link.Icon,
});
